import React, { useRef, useState } from "react";
import PropTypes from 'prop-types';
import { DayPickerRangeController, DayPickerSingleDateController } from 'react-dates';
import moment from "moment";
import { Popover } from "@mui/material";
import { CalendarIcon, CalendarInput, PickerWrapper } from "./styles";
import icon from '../../../assets/images/reservation/calendar-icon.svg';
import { formatLocalizedDate, formatLocalizedDateRange } from "../../../utils/dates";
import { getOutsideRangeByLimits } from "../../../utils/restrictions";

const DateRangePicker = props => {
    const { limits, startDate, endDate, placeholder, onDatesChange, error, editEndDate, editStartDate, contract, disabled } = props;
    const [focusedInput, setFocusedInput] = useState('startDate');
    const [focus, setFocus] = useState(false);
    const [open, setOpen] = useState(false);
    const anchorEl = useRef();
    let regEx = contract?.contract_type.match(/^\d+/);
    let numericPart = regEx ? parseInt(regEx[0]) : 0;


    const isOutsideRange = day =>
        getOutsideRangeByLimits(
            day,
            limits,
            startDate,
            endDate,
            true,
            focusedInput,
            contract?.available_from ? moment(contract?.available_from) : null,
            contract?.available_to ? moment(contract?.available_to).subtract(numericPart, 'months') : null
        );

    const calculateEndDate = startDate => {
        let endDate;
        if (contract?.contract_type.includes("MONTH") && regEx) {
            let months = numericPart;
            endDate = moment(startDate).add(months, 'M');
        }
        else {
            const years = regEx && numericPart;
            endDate = moment(startDate).add(years, 'y');
        }
        return endDate;
    }

    return (<>
        <CalendarInput onClick={() => {
            if(disabled) return;
            if ((editEndDate || editStartDate)) { setOpen(!open) }
            if (!editEndDate && !editStartDate) { setOpen(false) }

        }}
            ref={anchorEl} empty={!startDate && !endDate} error={error} disabled={disabled}>
            <CalendarIcon src={icon} alt="date-range-icon" />
            <span>
                {!startDate && !endDate && placeholder}
                {startDate && !endDate && `${formatLocalizedDate(startDate)} - `}
                {!startDate && endDate && ` - ${formatLocalizedDate(endDate)}`}
                {startDate && endDate && formatLocalizedDateRange(startDate, endDate)}
            </span>
        </CalendarInput>
        <Popover
            open={open}
            onClose={() => setOpen(false)}
            anchorEl={anchorEl.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <PickerWrapper>
                {editEndDate && editStartDate ? <DayPickerRangeController
                    initialVisibleMonth={() => moment(startDate || undefined)}
                    startDate={startDate}
                    endDate={endDate}
                    onDatesChange={dates => {
                        onDatesChange(dates);
                        if (dates.startDate && dates.endDate) {
                            setOpen(false);
                        }

                    }}
                    focusedInput={focusedInput}
                    onFocusChange={input => setFocusedInput(!input ? 'startDate' : input)}
                    hideKeyboardShortcutsPanel
                    noBorder
                    numberOfMonths={1}
                    daySize={Math.min(((window.innerWidth || 0) / 9) || 48, 48)}
                    weekDayFormat='ddd'
                    isOutsideRange={isOutsideRange}
                /> :
                    <DayPickerSingleDateController
                        initialVisibleMonth={() => moment(startDate || undefined)}
                        numberOfMonths={1}
                        daySize={Math.min(((window.innerWidth || 0) / 9) || 48, 48)}
                        dayPickerNavigationInlineStyles={{ color: 'red' }}
                        onDateChange={(date) => {
                            onDatesChange(
                                {
                                    startDate: date,
                                    endDate: calculateEndDate(date)
                                }

                            )
                            if (date) {
                                setOpen(false)
                            }
                        }}
                        date={startDate}

                        focused={true} // PropTypes.bool
                        onFocusChange={({ focused }) => setFocus(focused)}

                        isOutsideRange={isOutsideRange}
                        weekDayFormat='ddd'
                    />
                }
            </PickerWrapper>
        </Popover>
    </>)
}

DateRangePicker.propTypes = {
    limits: PropTypes.object,
    contract: PropTypes.object,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    placeholder: PropTypes.string,
    onDatesChange: PropTypes.func,
    error: PropTypes.bool,
    editStartDate: PropTypes.bool,
    editEndDate: PropTypes.bool,
}

export default DateRangePicker;
